import React from 'react';
import MuiSnackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { MessageType } from '../../models/common';

const Snackbar = ({ type = MessageType.Info, children, ...props }) => {
  return (
    <MuiSnackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      {...props}
    >
      <Alert elevation={6} variant="filled" severity={type}>
        {children}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
